// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs-module--breadcrumbs--RE4tn"};